define('rebrush/components/ui/selects/native',[
    'jquery',
    'lodash',
    'cartware/components/_base',
    'cartware/jquery/bem'
], function(
    $,
    _,
    Component,
    BEM
) {
    var SEMAPHORE_KEY               = 'component/ui/selects/native';
    var BLOCK_MODIFIER_JS_SUPPORT   = 'js-support';

    return Component.create({
        $init: function() {
            this.transformSelects();

            var debounceTransform = _.debounce(this.transformSelects, 1);

            $(document).ajaxComplete(debounceTransform);
            Ajax.Responders.register({
                onComplete: debounceTransform
            });
        },

        transformSelects: function() {
            BEM.block('select').filter(':modifier(native-mobile)').each(function() {
                var block = BEM.block(this);

                if (block.data(SEMAPHORE_KEY)) { return; }
                block.data(SEMAPHORE_KEY, true);

                function onChange(select) {
                    block.attr('data-selection', select.find('option:selected').text());
                }

                block.on('change', 'select', function(e) {
                    onChange($(e.currentTarget));
                });

                onChange(block.find('select'));

                block.addModifier(BLOCK_MODIFIER_JS_SUPPORT);
            });
        }
    });
});
